/* Muskoka first-touch capture. First-party cookies only. No query strings or personal data stored. */
(function () {
  try {
    var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
    var P = new URLSearchParams(location.search);
    var cur = {};
    KEYS.forEach(function (k) { var v = P.get(k); if (v) cur[k] = v.slice(0, 200); });

    function read(n) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function write(n, v, days) {
      document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + days * 86400 + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    }
    function stripUrl(u) { try { var x = new URL(u); return x.origin + x.pathname; } catch (e) { return ''; } }
    function host(u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }

    var refRaw = document.referrer || '';
    var external = refRaw && host(refRaw) !== location.hostname.replace(/^www\./, '');
    var ref = external ? stripUrl(refRaw) : '';
    var hasClick = !!(cur.gclid || cur.gbraid || cur.wbraid || cur.fbclid);

    function touch() {
      var src = cur.utm_source || (cur.gclid || cur.gbraid || cur.wbraid ? 'google' : cur.fbclid ? 'facebook' : (external ? host(refRaw) : 'direct'));
      var med = cur.utm_medium || (cur.gclid || cur.gbraid || cur.wbraid ? 'cpc' : cur.fbclid ? 'paid_social' : (external ? 'referral' : 'none'));
      return {
        s: src, m: med, c: cur.utm_campaign || '', t: cur.utm_term || '', ct: cur.utm_content || '',
        lp: location.origin + location.pathname, r: ref, d: new Date().toISOString(),
        g: cur.gclid || '', gb: cur.gbraid || '', wb: cur.wbraid || '', fb: cur.fbclid || ''
      };
    }

    if (!read('mk_ft')) write('mk_ft', JSON.stringify(touch()), 365);
    if (Object.keys(cur).length || external) write('mk_lt', JSON.stringify(touch()), 90);
  } catch (e) { /* never break the page */ }
})();
